<template>
    <div>
        <el-tabs v-model="activeTab" v-loading="isLoading">
            <el-tab-pane v-for="tab in tabPaneTemplate" :key="tab.key" :label="`${getTabLabel(tab)}`" :name="tab.key">
                <GroupItemEditor
                    ref="GroupItemEditor"
                    :data="groupItemSetting"
                    :headers="tab.headers"
                    :initActiveCategory="activeCategory"
                    @add="onGroupItemsAdd"
                    @update="onGroupItemsSortUpdate"
                    @updateData="updateData"
                    @edit="onEdit"
                    @onCategoryChange="onCategoryChange"
                ></GroupItemEditor>
            </el-tab-pane>
        </el-tabs>
        <IncomeStatementDetailEditor
            :visible="visible"
            :full-list="groupItemSetting"
            :target="target"
            :isTop="isTop"
            @delete="onDelete"
            @update="updateData"
            @close="onDialogClose"
            @closed="target = null"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import GroupItemEditor from './GroupItemEditor.vue';
import IncomeStatementDetailEditor from './IncomeStatementDetailEditor.vue';

export default {
    name: 'income-statement-editor',
    components: { GroupItemEditor, IncomeStatementDetailEditor },

    data() {
        return {
            activeTab: 'group-item-setting',
            activeCategory: 'invoiceSettings',
            tabPaneTemplate: [
                {
                    key: 'group-item-setting',
                    label: '群組項目設定',
                    headers: [
                        { key: 'categories', label: '類型', width: '250px' },
                        { key: 'groups', label: '大群組', width: '380px' },
                        { key: 'items', label: '子項目', width: 'auto' },
                    ],
                },
                {
                    key: 'group-analysis-setting',
                    label: '群組分析對照表',
                    headers: [
                        { key: 'categories', label: '類型', width: '250px' },
                        {
                            key: 'groups-contrast',
                            label: '群組對照設定',
                            width: 'auto',
                        },
                    ],
                },
            ],

            isLoading: false,
            groupItemSetting: {},

            visible: false,
            target: null,
            isTop: false,
        };
    },
    created() {
        this.updateData();
        if (!this.isAuth('G02')) this.tabPaneTemplate.pop();
    },
    computed: {
        ...mapGetters({
            isAhooAgent: 'account/isAhooAgent',
            menuGroups: 'menu/menuGroups',
        }),
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'Tool/GetIncomeStatementSettings',
                    method: 'GET',
                });
                this.groupItemSetting = { ...resp.data };

                this.$nextTick(() => {
                    if (this.$refs.GroupItemEditor.length) {
                        this.$refs.GroupItemEditor.forEach((com) => {
                            com.init();
                        });
                    }
                });
            } finally {
                this.isLoading = false;
            }
        },

        async onGroupItemsSortUpdate(items) {
            try {
                await this.$api({
                    url: '/IncomeStatementSettingPage/UpdateSort',
                    method: 'POST',
                    data: { items },
                });
            } finally {
                this.updateData();
            }
        },
        async onGroupItemsAdd(target) {
            this.target = {
                parent: target.group,
                category: target.category,
            };
            this.isTop = target.isTop;
            this.onDialogOpen();
        },
        async onDelete({ sno, isGroup }) {
            const target = isGroup ? 'Group' : 'Item';

            try {
                await this.$api({
                    url: `/IncomeStatementSettingPage/Delete${target}`,
                    method: 'POST',
                    data: { sno },
                });
                this.onDialogClose();
            } finally {
                this.updateData();
            }
        },
        onCategoryChange(category) {
            this.activeCategory = category;
        },
        onEdit(target) {
            this.target = {
                ...target.data,
                parent: target.group,
                category: target.category,
            };
            this.onDialogOpen();
        },
        onDialogOpen() {
            this.visible = true;
        },
        onDialogClose() {
            this.visible = false;
        },
        getTabLabel(tab) {
            if (tab.key === 'group-item-setting') return tab.label;
            return `${tab.label}${this.isPayed('D18') && this.isPayed('D19') ? '' : '（未完整購買）'}`;
        },
    },
};
</script>
